/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q6_QuestionInputs */

const en_faq_q6_question = /** @type {(inputs: Faq_Q6_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is an exclusion?`)
};

const fr_faq_q6_question = /** @type {(inputs: Faq_Q6_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'une exclusion ?`)
};

/**
* | output |
* | --- |
* | "What is an exclusion?" |
*
* @param {Faq_Q6_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q6_question = /** @type {((inputs?: Faq_Q6_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q6_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q6_question(inputs)
	return fr_faq_q6_question(inputs)
});